<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="请输入项目编号" v-model="project.number"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目需求单位">
      <el-input size="small" :disabled="true" v-model="project.deptName"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="project.leader.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="project.leader.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目名称">
      <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="已完成工程内容">
      <el-input type="textarea" placeholder="请输入已完成工程内容" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.wcContent"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="进度百分比">
          <el-input size="small" type="number" placeholder="请输入已完成进度百分比" v-model="form.rate"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="完成投资额(元)">
          <el-input size="small" type="number" placeholder="请输入已完成投资额"v-model="form.wctze"></el-input>
        </el-form-item>
      </el-col>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
      }
    },
    mounted() {
      this.form = this.formByFather

      // this.form.depId = this.userData.secDepIds.split(",")[0]
      // this.form.leaderId = this.userData.id
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createProgress.vue